import { render } from "./TrenKarbon.vue?vue&type=template&id=b695ab5a"
import script from "./TrenKarbon.vue?vue&type=script&lang=js"
export * from "./TrenKarbon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/christinandrea/kel1-kedaireka/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__